import type { Fields, Entry } from '../types';
import { generateID } from './createUniqueIDs';

function isEntry(obj: unknown): obj is Entry {
    return (obj as Entry).sys !== undefined;
}

function handleSysKey(entries: Entry, newFieldEntry: Fields) {
    for (const fieldKey in entries.sys) {
        const type = entries.sys[fieldKey as keyof (typeof entries)['sys']] as Fields;
        if (isEntry(type) && fieldKey === 'contentType' && type.sys) {
            newFieldEntry.sysType = type.sys.id;
        }
    }
}
const removeSysMetadata = <U extends Entry>(entries: U, ids: Record<string, number> = {}): Fields | Fields[] => {
    const seenIDs = ids;

    function handleFieldsKey(entry: Entry, newFieldEntry: Fields) {
        for (const fieldKey in entry.fields) {
            newFieldEntry[fieldKey] = removeSysMetadata(entry.fields[fieldKey] as Entry);
        }
    }

    const newFieldEntry: Fields = {};

    if (Array.isArray(entries)) {
        return entries.map(entry => removeSysMetadata(entry)) as Fields[];
    }
    if (typeof entries !== 'object' || entries === null) {
        return entries;
    }

    for (const key in entries) {
        if (key === 'metadata') {
            continue;
        }

        if (key === 'sys') {
            handleSysKey(entries, newFieldEntry);
            continue;
        }

        if (key === 'fields') {
            handleFieldsKey(entries, newFieldEntry);
            continue;
        }

        newFieldEntry[key] = removeSysMetadata(entries[key] as U);
    }

    if (entries.fields && entries.sys?.id) {
        newFieldEntry.sysId = generateID(entries.sys.id, seenIDs);
    }

    return newFieldEntry;
};

export function propsMapper<T>(entries: Fields | Fields[]): T[] {
    if (entries === null || entries === undefined) {
        return [];
    }

    if (Array.isArray(entries)) {
        return entries.map(propsMapper) as T[];
    }

    const seenIDs = {};

    if (typeof entries === 'object') {
        const newEntries = removeSysMetadata(entries, seenIDs) as Fields;
        return newEntries.fields ? { ...(newEntries.fields as unknown as T[]) } : (newEntries as unknown as T[]);
    }

    return entries as T[];
}
